<template>
<!-- <TagManageForObject :type="'1'" @Update="UpdateTags" ref="TagManage"></TagManageForObject> -->
<div>
	<Window :title="getLanguageStr('word1787','编辑所属标签')" :footerButton="this.isBatch?true:false" ref="Window" @Save='save' @Closed='Closed'>
		<Core :id="option.id" :isBatch=isBatch :type="type" @Update="(action,data)=>{$emit('Update',action,data);}" ref="Core"></Core>
	</Window>
</div>
</template>
<script>
import Window from "@/components/common/ui/WindowForSetting.vue";
import Core from "@/components/common/tagManage/Core.vue";
// import InputText from "@/components/common/ui/InputText.vue";
import Loading from "@/components/common/ui/Loading.vue";

import {getLanguageStr} from "@/util/language.js";
import * as lib from "@/util/lib.js";

import {getTags,apiAddTag,apiDeleteTag,apiUpdateTag} from "@/api/manage/tag.js";
export default{
	name:"TagManage",
	components:{Window,Core,Loading},
	props:{
		type:{
			type:[String,Number],
			default:1
		},
		isBatch: {
			type: Boolean,
			default:false
		}
	},
	data(){
		return{
			option:{
				id:null,//对象id
			},
			tagList:[],//当前对象的标签列表
			allTag:[],//所有电站标签
      dymamicCom:null,
			addMode:false,//是否在添加模式

			newTagName:""//新建标签的名称
		}
	},
	methods:{
		getLanguageStr,
		objTool:lib.objTool,
		show:function(data,dymamicCom){
      if(dymamicCom) this.dymamicCom  = dymamicCom
			statistic('A25','A2501')
			let pass=false;
			switch(Number(this.type)){
				case 1://电站
					pass=lib.doPermissions("A/B/A16");
					break;
			}
			if(pass){
				
				this.option.id=this.isBatch? null : data;

				// this.$refs.Window.loadStatusAction(true);
				this.$refs.Core.show(this.isBatch?data:this.option.id);
				this.$refs.Window.show({
					end:()=>{
						// this.getTag();
						// this.getAllTag();
					}
				});
			}
			else this.$notify($t('phrase783',['你没有权限，请联系本商家超级管理员开启']));
    },
    Closed () {
     if(this.dymamicCom){
       this.dymamicCom.destroyUi()
     }
    },
		save(){
			this.$refs.Core.saveBatch().then(_=>{
				this.hide()
			}).catch(_=>{
			//	console.log(_)
			})
		},
		hide:function(){
			this.$refs.Window.hide();
		}
	},
	created(){},
	mounted(){
		this.$refs.Window.loadStatusAction(false);
	}
}
</script>
<style lang="scss" scoped>
.enableList{padding:0 .5em .5em 0;position:relative;}
</style>


// WEBPACK FOOTER //
// src/components/common/tagManage/ForObject.vue